import { Http } from "@/utils/http";

export default class QuizzService {
  public static async quizzs() {
    const targetUrl = `${process.env.VUE_APP_API_APP}/?task=quizzs`;
    const { data: response } = await Http.instance.get(targetUrl);
    return response.data;
  }
}
